module.exports = __webpack_public_path__ + "img/TCD.9623a558.svg";